import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TabBarVariantModel } from './typings/tab-bar-variant';
import { TabModel }           from './typings/tab';

// A row of tabs or a segmented toggle; emits the chosen value and leaves the content to the caller
@Component({
  selector   : 'wor-tab-bar',
  template: require('./tab-bar.component.html')
})
export class TabBarComponent {
  @Input() isDisabled : boolean            = false;
  @Input() selected   : string;
  @Input() tabs       : Array<TabModel>    = [];
  @Input() variant    : TabBarVariantModel = 'pill';

  @Output() selectedChange : EventEmitter<string> = new EventEmitter<string>();

  select ( tab : TabModel ) : void {
    if ( this.isDisabled || tab.isDisabled || tab.value === this.selected ) {
      return;
    }

    this.selectedChange.emit(tab.value);
  }

  trackTab ( index : number, tab : TabModel ) : string {
    return tab.value;
  }
}
